import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { DataGrid } from '@material-ui/data-grid';
import { Button, Modal, Form, Row, Col, InputGroup } from "react-bootstrap"; 
import SearchIcon from '@material-ui/icons/Search';

import * as Admin from "../../../store/ducks/admin.duck";
import { Grid, Paper } from '@material-ui/core';

import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function MedipassCodes() {

  const [searchTerm, setSearchTerm] = useState('')
  const billingServices = useSelector(state => state.admin.BillingServices)

  const filteredBillingServices = billingServices.filter(billingService => billingService.name.search(searchTerm.toLowerCase()) > -1 || searchTerm.length === 0 )
  const role = useSelector(state =>  state.auth.roleDesc)

  const dispatch = useDispatch()
  useEffect( () => { dispatch(Admin.actions.fetchBillingServices()) }, [dispatch] )

  var [show, setShow] = useState(false);


  var [currentServiceID,setCurrentServiceID] = useState();
  var [currentName,setCurrentName] = useState();
  var [currentDescription,setCurrentDescription] = useState();
  var [currentUnit,setCurrentUnit] = useState();
  var [currentCost,setCurrentCost] = useState();
  var [currentCancelCost,setCurrentCancelCost] = useState();
  var [currentPaymentType,setCurrentPaymentType] = useState();
  var [currentXeroServiceCode,setCurrentXeroServiceCode] = useState();
  var [currentStatus,setCurrentStatus] = useState();

  const loadServiceDetail = (thisService) => {
    setCurrentServiceID(thisService.id);
    setCurrentName(thisService.name);
    setCurrentDescription(thisService.description);
    setCurrentUnit(thisService.unit);
    setCurrentCost(thisService.cost);
    setCurrentCancelCost(thisService.cancelCost);
    setCurrentPaymentType(thisService.paymentType);
    setCurrentXeroServiceCode(thisService.xeroServiceCode);
    setCurrentStatus(thisService.status);
    setShow(true)
  }

  const createNewBillingService = (thisService) => {
    setCurrentServiceID(0);
    setCurrentName();
    setCurrentDescription();
    setCurrentUnit();
    setCurrentCost('0');
    setCurrentCancelCost('0');
    setCurrentPaymentType();
    setCurrentXeroServiceCode();
    setCurrentStatus();
    setShow(true)
  }

  function putBillingService() {
    // Create payload to send to API
    var payload = {
      id: currentServiceID,
      name: currentName,
      description: currentDescription,
      unit: currentUnit,
      cost: currentCost,
      cancelCost: currentCancelCost,
      paymentType: currentPaymentType,
      xeroServiceCode: currentXeroServiceCode,
      status: currentStatus
    }
    //
    process.env.REACT_APP_DEBUG && console.log(payload);
    process.env.REACT_APP_DEBUG && console.log ('Saving data');
    // Save update 
    dispatch(Admin.actions.putBillingService(payload));
    setShow(false);
  }


  const columns = [
    { field: 'id', headerName: 'ID', width: 100,  hide: true },
    { field: 'name', headerName: 'Name', width: 250,  
      renderCell: (params) => (
        <strong>
          {(params.row.istemplate === 0) || (role === 'Admin') ?
            <div onClick={() => loadServiceDetail(billingServices.find(billingService => billingService.id === params.row.id))} className="cell-Link" >
              {params.value}
            </div>
          :
            <div>
              {params.value}
            </div>
        }
        </strong>
      ),  
    },
    { field: 'description', headerName: 'Description', width: 400 },
    { field: 'cost', headerName: 'Cost', width: 120 },
    { field: 'cancelCost', headerName: 'Cancel', width: 120 },
    { field: 'paymentType', headerName: 'Service Key', width: 170 },
    { field: 'xeroServiceCode', headerName: 'Xero Code', width: 150 },
    { field: 'status', headerName: 'Status', width: 120 },
  ];

  
  function handleClose() {
    setShow(false);
  }  

  const handleSearch = (event) => {
    const searchTerm = event.target.value    
    setSearchTerm(searchTerm)
  }


  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item><h4 style={{ marginBottom: 12 }}>Billing Service Maintenance</h4></Grid>
      </Grid>

      <Paper> 
        <Grid container justifyContent="space-between" style={{ padding: 10 }}>
          <Grid item style={{ marginTop: 2, marginLeft: 10 }}>
            <InputGroup size="sm" >
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control                  
                  type="text"
                  value={searchTerm}
                  onChange={(event) => handleSearch(event)}
                  autoComplete='OFF'
                />
              </InputGroup>
          </Grid>
          <Grid item style={{ marginLeft: 20, marginRight: 10 }}>
            <Button variant="primary" size="sm" onClick={() => createNewBillingService()}>
              Create Billing Service
            </Button>
          </Grid>
        </Grid>
      </Paper>


      { billingServices ? 
        <Paper style={{ height: 700 }}>
          <DataGrid rows={filteredBillingServices} columns={columns} pageSize={20} checkboxSelection={false} rowHeight={40} />
        </Paper>
      : ('None')
      }

      <Modal show={show} onHide={handleClose} dialogClassName="contracts-modal">
        <Modal.Header closeButton className="contracts-modal">
          <Modal.Title>Service Maintenance </Modal.Title>
        </Modal.Header>
        <Modal.Body className="contracts-modal">
          <Row>
            <Col md="3">
              <Form.Group >
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentName} onBlur={(event) => setCurrentName(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form.Group >
                <Form.Label>Description</Form.Label>
                <textarea className="form-control" rows="3" name="Description" defaultValue={currentDescription} onBlur={(event) => setCurrentDescription(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group >
                <Form.Label>Xero Service Code (Must be Configured in Xero)</Form.Label>
                <Form.Control type="text" name="XeroServiceCode" defaultValue={currentXeroServiceCode} onBlur={(event) => setCurrentXeroServiceCode(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group >
                <Form.Label>Unit (Set to 1)</Form.Label>
                <Form.Control type="text" name="Unit" defaultValue={currentUnit} onBlur={(event) => setCurrentUnit(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group style={{width: "100%"}}>
                <Form.Label style={{ color: 'green', fontWeight: 500 }}>Service</Form.Label>
                <Form.Control type="text" name="PaymentType" defaultValue={currentPaymentType} onBlur={(event) => setCurrentPaymentType(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group >
                <Form.Label>Cost</Form.Label>
                <Form.Control type="text" name="Cost" defaultValue={currentCost} onBlur={(event) => setCurrentCost(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group >
                <Form.Label>Cancellation Cost</Form.Label>
                <Form.Control type="text" name="CancelCost" defaultValue={currentCancelCost} onBlur={(event) => setCurrentCancelCost(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="3">
                <Form.Group >
                  <Form.Label>Status</Form.Label>
                  <Form.Control as="select" defaultValue={currentStatus} onBlur={(event) => setCurrentStatus(event.target.value)}>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Control>
                </Form.Group>
              </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer className="contracts-modal">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={putBillingService}>
            Save
          </Button>
        </Modal.Footer>

      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />     
    </>
  )
}
